import { TaxAdvantageResp } from '@/api/tax-guide';
import { FormGroup, Stack, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

type Props = {
  layoutType?: 'withSubHeader' | 'withoutSubHeader' | 'clientPreview';
  onChange: (e: boolean) => void;
  taxAdvResp?: TaxAdvantageResp;
};

export const TaxAdvantage = (props: Props) => {
  const { layoutType, onChange, taxAdvResp } = props;
  const [toggleValue, setToggleValue] = useState(taxAdvResp?.displayToggle);

  useEffect(() => {
    setToggleValue(taxAdvResp?.displayToggle);
  }, [taxAdvResp?.displayToggle]);

  if (!taxAdvResp) return null;

  return (
    <FormGroup>
      <Stack
        direction="row"
        spacing={0}
        sx={
          layoutType === 'withoutSubHeader'
            ? { alignItems: 'center', paddingLeft: 4 }
            : { alignItems: 'center', paddingRight: 2 }
        }
        // display={disabled ? 'none' : 'flex'}
      >
        <Typography fontSize={12} sx={{ paddingRight: 2 }}>
          Tax Favorable Regime:
        </Typography>
        <Switch
          inputProps={{
            'aria-label': 'Tax Favorable Regime Toggle',
            'aria-roledescription': 'switch',
          }}
          ///disabled={disabled}
          checked={toggleValue}
          onChange={() => {
            const newVal = !toggleValue;
            setToggleValue(newVal);
            onChange(newVal);
          }}
        />
      </Stack>
    </FormGroup>
  );
};
